import { Button } from 'antd';
import { DataSecurityApplicationStatus } from '@sonar-software/sonar-core';
import { Link } from 'react-router-dom';
import React from 'react';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { useApplicationReference, useCurrentUser } from '@hooks';
export const EditAppButton = ({ applicationId }) => {
    const { status } = useApplicationReference(applicationId);
    const { isReadOnly } = useCurrentUser();
    const isDetected = status === DataSecurityApplicationStatus.Detected;
    if (isReadOnly || isDetected) {
        return null;
    }
    return (React.createElement(Link, { to: FULL_ROUTES.DATA_SECURITY_APPLICATION_SETUP },
        React.createElement(Button, { type: 'default' }, COPY_SPECIFIC.EDIT_APP)));
};
